import { FC, memo } from 'react';
import {
  Box,
  Separator,
  Stack,
  SystemStyleObject,
  Text,
} from '@chakra-ui/react';

import { childrenExceptTypeEdge } from '~/core/shared/utils/styles';
import { useEvaluatedValue } from '../../hooks/useEvaluatedValue';
import { BlocksRenderer } from '../BlocksRenderer/BlocksRenderer';
import { ExistingValuesCardProps } from './types/ExistingValuesCardProps';
import { DataSectionPresenter } from './DataSectionPresenter';

// TODO: @haxxxton - find a way to avoid needing to do this.. likely with Stack
const cssStyles: Record<string, SystemStyleObject> = {
  [childrenExceptTypeEdge('first')]: {
    pt: 4,
  },
  [childrenExceptTypeEdge('last')]: {
    pb: 4,
  },
};

const hideLastSeparator: SystemStyleObject = {
  '& > hr:last-of-type': {
    display: 'none',
  },
};

const ExistingValuesCardComponent: FC<ExistingValuesCardProps> = ({
  existingValues,
  namePrefixes,
  workflowDataResolverDependencies,
  parentContext,
}) => {
  const resolvedHeader = useEvaluatedValue(
    existingValues.heading,
    workflowDataResolverDependencies,
  );

  return (
    <Box borderWidth="1px" p={6}>
      <Stack gap={8}>
        <Stack gap={6}>
          <Text fontSize="xl" fontWeight="medium">
            {resolvedHeader}
          </Text>

          <Separator variant="heading" />
        </Stack>

        <Stack css={hideLastSeparator} gap={8}>
          {existingValues.sections.map((dataSection, i) => (
            <DataSectionPresenter
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              parentContext={parentContext}
              workflowDataResolverDependencies={
                workflowDataResolverDependencies
              }
              {...dataSection}
            >
              <Separator as="hr" />
            </DataSectionPresenter>
          ))}
        </Stack>

        <Stack gap={8}>
          {!existingValues.options?.hideDivider && <Separator />}

          <Box css={cssStyles}>
            <BlocksRenderer
              blocks={existingValues.formBlocks}
              namePrefixes={namePrefixes}
              workflowDataResolverDependencies={
                workflowDataResolverDependencies
              }
            />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export const ExistingValuesCard = memo(ExistingValuesCardComponent);
